/* eslint-disable no-restricted-imports */

import React,{ PropsWithChildren } from 'react';
import { I18nextProvider } from 'react-i18next';


import i18n from './init';

type Props = PropsWithChildren;

export const LocaleProvider: React.FC<Props> = ({ children }) => {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};
